package com.ervasstudio.tracoemovimento.pages.projecto

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.px

@Composable
fun HeroStrokeText(text: String, isMobile: Boolean, topPadding: CSSSizeValue<CSSUnit.px> = 0.px) {
    Box(modifier = Modifier.padding(top = topPadding, leftRight = if (isMobile) 4.px else 10.px)) {
        SpanText(
            modifier = Modifier
                .fontSize(if (isMobile) 40.px else 160.px)   // era 160.px
                .fontFamily("GothamBlack")
                .fontWeight(FontWeight.Bold)
                .lineHeight(1)
                .color(Colors.Transparent)
                .styleModifier {
                    property("-webkit-text-stroke", if (isMobile) "1px black" else "2px black")
                    property("paint-order", "stroke fill")
                },
            text = text
        )
    }
}